<template>
  <artmisads-modal :maskClosable="false" v-model:open="visible" :title="st('placement.applicationModalTitle')" :width="720"
   @cancel="handleClose">
    <div class="application-model">
      <a-form ref="formRef" :model="formData" layout="vertical">
        <a-form-item :label="st('placement.applicationFieldTitle')" name="title" :rules="rules.title" >
          <a-input v-model:value="formData.title" :maxlength="100" />
        </a-form-item>
        <a-form-item :label="st('placement.applicationFieldDescription')" name="description"  :rules="rules.description">
          <a-textarea v-model:value="formData.description" :maxlength="200" :auto-size="{ minRows: 3, maxRows: 5 }"
            />
        </a-form-item>
        <div>
          {{ st('placement.applicationSelectBrand') }}
        </div>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item name="sellerName">
              <div ref="sellerRef">
                <a-select v-model:value="formData.sellerName" :options="sellerNameOptions" @change="getSellerBrandsName"
                show-search option-filter-prop="label" :placeholder="$t('seller.common.amazonSellerName')" :getPopupContainer="() => $refs.sellerRef"/>
              </div>
            
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="brand">
              <div ref="brandRef">
              <a-select v-model:value="formData.brandId" :options="brandOptions" @change="getSellerBrands" show-search :placeholder="$t('seller.common.brand')"
                option-filter-prop="label"  :getPopupContainer="() => $refs.brandRef"/>
                </div>
            </a-form-item>
          </a-col>
        </a-row>
      
        <a-form-item name="ASINs" :label="st('placement.applicationSelectAsinsMax', { n: maxAsin })" >
          <div ref="operationRef">
          <a-select @change="getASINs" v-model:value="formData.productIds" :options="ASINsOptions" mode="multiple"
            show-search option-filter-prop="label" :getPopupContainer="() => $refs.operationRef"/>
       
          </div>
        </a-form-item>
        <div>
          <artmisads-table :columns="columns" :data-source="dataSource" :scroll="{ x: 900, y: 600 }" :pagination="{
            total: pagination.total,
            pageSize: pagination.pageSize,
            current: pagination.page,
          }" :change="onChangePage">
            <template #bodyCell="{ column, text, index, record }">
              <template v-if="column.name === 'product'">
                <a class="product-name" target="_blank" :href="`/seller/product/${record.id}`">
                  <div class="product-img-show" :style="record.imageUrl ? { 'background-color': '#ffffff' } : ''">
                    <img :src="record.imageUrl" alt="" v-if="record.imageUrl" />
                  </div>
                  <div class="product-title">
                    <div>
                      {{ record.title }}
                    </div>
                    <div class="asin">{{ record.asin }}</div>
                  </div>
                </a>
              </template>
            </template>
          </artmisads-table>
          <a-form-item name="upload" >
            <template #label>
              <div class="upload-label">
                <div class="upload-label-text">
                {{ st('placement.applicationUploadResources') }}
              </div>
              <div class="upload-label-small">
                {{ st('placement.applicationUploadHint') }}
              </div> 
              </div>
              
            </template>
            <div class="upload-container">
              <a-upload 
                accept=".zip,.rar,.jpg,.png,.jpeg,.gif,.pdf,application/zip,application/x-rar-compressed,application/vnd.rar,image/jpeg,image/png,image/jpg,image/gif,application/pdf"
                v-model:fileList="formData.upload" name="logo" max-count="10" :custom-request="customUpload"
                list-type="picture" @remove="handleRemove" :before-upload="beforeUpload" @change="handleUploadChange"
                :show-upload-list="true">
                <artmisads-select-button >
                  {{ st('placement.applicationUploadButton') }}
                </artmisads-select-button>
              </a-upload>

            </div>
          </a-form-item>
        </div>
      </a-form>
    </div>
    <template #footer>
      <div style="overflow: hidden;">
        <div class="footer-text">
          {{ st('placement.applicationFooterEscrow') }}
        </div>
      <a-button style="float: right" key="submit" type="primary" :loading="loading"
        @click="handleSave">{{ st('placement.applicationSubmit') }}</a-button>
      
      </div>
 
    </template>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref, defineEmits, defineExpose, computed } from 'vue'
import { sellerPlacementApi } from '~/server/index'
import { brandApi } from "@/server/index"
import adminApi from '~/server/seller/admin'
import { message } from 'ant-design-vue'
import { useUserInfoStore } from '~/storeData/index'
import { COUNTRY_BASE } from '~/contants/common'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
const store = useUserInfoStore()
const visible = ref(false)
const emit = defineEmits(['refresh'])
const formRef = ref(null)
const sellerNameOptions = ref([])
const brandOptions = ref([])
const ASINsOptions = ref([])
const uploadImageUrl = ref('')
const columns = computed(() => [
  {
    title: st('placement.applicationColProduct'),
    dataIndex: 'product',
    name: 'product',
    width: 200,
  },
  {
    title: st('placement.applicationColAsin'),
    dataIndex: 'asin',
    width: 100,
  },
  {
    title: st('placement.applicationColPrice'),
    dataIndex: "price",
    width: 100,
    customRender: ({ text, record }) => {
      return <div class="product-price">{record.currencySymbol}{text}</div>
    },
  },
  {
    title: st('placement.applicationColCommission'),
    key: "commission",
    dataIndex: "commission",
    width: 100,
    customRender: ({ text, record }) => (
      <div class="product-commission" style={{ 'opacity': record.status == 'active' ? '1' : '0.3' }}>{text.toFixed(1)}%</div>
    ),
  },
  {
    title: st('placement.applicationColStatus'),
    dataIndex: 'status',
    width: 100,
  },
])
const exampleFiles = ref([

])
const rules = computed(() => ({
  title: [{ required: true, message: st('placement.applicationRuleTitleRequired') }],
  description: [{ required: true, message: st('placement.applicationRuleDescriptionRequired') }],
  upload: [{ required: true, message: st('placement.applicationRuleUploadRequired') }]
}))
const marketplace = ref('')
const loading = ref(false)
const maxMap = ref()
const dataSource = ref([])
const pagination = ref({
  total: 0,
  page: 1,
  pageSize: 10,
})
const onChangePage = (page, pageSize) => {
  pagination.value.page = page
  pagination.value.pageSize = pageSize
  getSellerBrandsList()
}
const getSellerBrandsList = async () => {

}
const getSellerConnections = async () => {
  const parma = {
    page: 1,
    pageSize: 10000,
  }
  const res = await sellerPlacementApi.getSellerConnections(parma)

  sellerNameOptions.value = res.data.data.map(item => {
    return {
      label: item.amazonName,
      value: item.amazonUserId,
    }
  })
}
const getSellerBrandsName = async (amazonUserId) => {

  formData.value.brandId = null
  formData.value.productIds = []
  brandOptions.value = []
  ASINsOptions.value = []
  dataSource.value = []
  const res = await sellerPlacementApi.getSellerBrands({
    amazonUserId: amazonUserId
  })
  brandOptions.value = res.data.map(item => {
    return {
      label: item.amazonBrandName,
      value: item.id,
    }
  })
}
function getBase64 (img, callback) {
  const reader = new FileReader()

  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
const getASINs = async (list) => {
  dataSource.value = []
 
  if(formData.value.productIds.length > maxAsin.value){
    message.error(st('placement.applicationErrAsinExceed', { n: maxAsin.value }))
    formData.value.productIds = formData.value.productIds.slice(0,maxAsin.value)
  }
  formData.value.productIds.forEach(item => {
    if (maxMap.value.get(item)) {
      dataSource.value.push(maxMap.value.get(item))
    }
  })
}
const getSellerBrands = async (amazonBrandId) => {
  if (amazonBrandId) {
    ASINsOptions.value = []
    formData.value.productIds = []
    dataSource.value = []
    maxMap.value = new Map()
    const res = await brandApi.getBrandProduct({
      brandId: amazonBrandId,
      page: 1,
      size: 10000,
    })
    ASINsOptions.value = res.data.data.map(item => {
      maxMap.value.set(item.id, item)
      return {
        label: item.asin,
        value: item.id,
      }
    })
  }
}
const maxAsin = ref(0)
const formData = ref({
  placementId:'',
  title: '',
  description: '',
  marketplace: '',
  brandId: null,
  productIds: [],
  upload: [],
})
const handleClose = () => {
  visible.value = false
}
const handleOpen = (id,maxAsinCount) => {
  visible.value = true
  exampleFiles.value=[]
  marketplace.value =COUNTRY_BASE.find(item => item.countryCode === store.userInfo.countryCode).host
  maxAsin.value = maxAsinCount||0
  formData.value={
  placementId:id,
  title: '',
  description: '',
  marketplace: marketplace.value,
  brandId: null,
  productIds: [],
  upload: [],
}


dataSource.value=[]
  setTimeout(() => {
  formRef.value.resetFields()

  }, 0)
  getSellerConnections()
}
const handleRemove = (file) => {
  // console.log(file, 'file')
  exampleFiles.value = exampleFiles.value.filter(item => item.originalFileName !== file.name)
  // console.log(exampleFiles.value,'exampleFiles.value')
}
// 文件上传前的验证
const beforeUpload = (file) => {
  const allowedTypes = [
    'application/zip',
    'application/x-rar-compressed',
    'application/vnd.rar',
   
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'application/pdf'
  ]

  const allowedExtensions = ['.zip', '.rar', '.jpg', '.jpeg', '.png', '.gif', '.pdf']

  const isValidType = allowedTypes.includes(file.type)
  const isValidExtension = allowedExtensions.some(ext =>
    file.name.toLowerCase().endsWith(ext)
  )

  if (!isValidType && !isValidExtension) {
    message.error(st('placement.applicationErrFileType'))
    return false
  }

  const isLt50M = file.size / 1024 / 1024 < 10
  if (!isLt50M) {
    message.error(st('placement.applicationErrFileSize'))
    return false
  }

  return true
}

// 处理上传状态变化
const handleUploadChange = (info) => {
  const { file, fileList } = info
  // if (info.file.status === 'uploading') {
  //   spinning.value = true;
  //   return
  // }

  if (file.status === 'done') {
    getBase64(file.originFileObj, (base64Url) => {
      uploadImageUrl.value = base64Url
    })
  }
  // 如果上传失败，清除错误状态
  if (file.status === 'error') {
    message.error(st('placement.applicationErrUploadFailed'))
    // 自动清除失败的文件
    setTimeout(() => {
      formData.value.upload = fileList.filter(item => item.status !== 'error')
    }, 2000)
  }

}

// 自定义上传处理
const customUpload = (options) => {
  const { file, onSuccess, onError, onProgress } = options

  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif']

  const isValidExtension = allowedExtensions.some(ext =>
    file.name.toLowerCase().endsWith(ext)
  )
  loading.value = true
  if (isValidExtension) {
    const data = {}

    if (file) {
      data.file = file
    } else {
      data.url = encodeURIComponent(uploadImageUrl.value)
    }
    // 模拟上传进度
    adminApi.uploadImg(data).then((res) => {

      onSuccess({
        url: URL.createObjectURL(file),
        name: file.name,
        status: 'done'
      })
      exampleFiles.value.push({
        originalFileName: file.name,
        url: res.data.url
      })
    }).catch(e => {
      console.log(e)
    }).finally(() => {
      loading.value = false
    })
  }
  else {
    let form = new FormData();
    form.append('file', file);
  
    adminApi.uploadFile(form).then(res => {
      
      onSuccess({
        url: URL.createObjectURL(file),
        name: file.name,
        status: 'done'
      })
      exampleFiles.value.push({
        originalFileName: file.name,
        url: res.data.url
      })
    }).finally(() => {
      loading.value = false
    })


  }

}
const handleSave = () => {
  loading.value = true
  formRef.value.validate().then(res => {
    const params = {
      ...formData.value,
      resourceFiles: exampleFiles.value,
    }
    delete params.upload
    sellerPlacementApi.createPlacement(params).then(res => {
     
      if (res.success) {
        // message.success('Create Placement Successfully')
        handleClose()
        emit('refresh')
      }else{
        message.error(res.error)
      }
    }).finally(() => {
      loading.value = false
    })
    }).catch(err => {
      console.log(err,'err')
    })  
}
defineExpose({
  handleOpen
})
</script>
<style scoped lang="less">
.upload-label{
  display: flex;
  align-items: center;
  flex: 1;
}
.upload-label-text{
  font-size: 14px;
  color: var(--dark-1);
  font-weight: 500;
  
  flex: 1;
}
.upload-label-small{
  font-size: 10px;
  color: var(--dark-2);
  margin-left: 8px;
 
}
.footer-text{
  font-size: 14px;
  
  margin-top: 16px;
  line-height: 20px;
  text-align: left;
}
.product-name {
  display: flex;
  align-items: center;

  .product-title {
    flex: 1;
    margin-left: 12px;

    div:first-of-type {
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      color: var(--dark-1);
      letter-spacing: 0.4px;
      line-height: 22px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-decoration: underline;
    }

    div:last-of-type {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }

    .asin {
      margin-top: 2px;
    }
  }

  .product-img-show {
    width: 56px;
    height: 56px;
    background: var(--bg-gray-2);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    :deep(img) {
      
      max-height: 56px;
      object-fit: contain;
    }
  }
}
</style>